/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SkillsControllerFindOneQueryResponse, SkillsControllerFindOnePathParams, SkillsControllerFindOne400, SkillsControllerFindOne401, SkillsControllerFindOne403, SkillsControllerFindOne404 } from "../../models/skillsController/SkillsControllerFindOne";

function getSkillsControllerFindOneUrl(id: SkillsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/skills/${id}` as const }  
  return res
}

/**
 * @summary Get a visible skill with live S3 files
 * {@link /api/v1/skills/:id}
 */
export async function skillsControllerFindOne(id: SkillsControllerFindOnePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SkillsControllerFindOneQueryResponse, ResponseErrorConfig<SkillsControllerFindOne400 | SkillsControllerFindOne401 | SkillsControllerFindOne403 | SkillsControllerFindOne404>, unknown>({ method : "GET", url : getSkillsControllerFindOneUrl(id).url.toString(), ... requestConfig })  
  return res.data
}